/**
 * "Save my number" (spec 2026-10-14 §6.2): a vCard 3.0 with Bash's name, his
 * number and his face, so the first ring comes from a contact (a phone set to
 * silence unknown callers lets it through). Lines end CRLF and fold at 75.
 */
const FACE_URL = "/contact/bash-face.jpg";

function fold(line: string): string {
  if (line.length <= 75) return line;
  const parts = [line.slice(0, 75)];
  for (let i = 75; i < line.length; i += 74) parts.push(` ${line.slice(i, i + 74)}`);
  return parts.join("\r\n");
}

export function buildBashVCard(o: {
  number: string;
  photoJpegBase64?: string;
}): string {
  const lines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    "N:;Bash;;;",
    "FN:Bash",
    "ORG:Vestra",
    `TEL;TYPE=CELL,VOICE:${o.number}`,
  ];
  if (o.photoJpegBase64) {
    lines.push(`PHOTO;ENCODING=b;TYPE=JPEG:${o.photoJpegBase64}`);
  }
  lines.push("END:VCARD");
  return `${lines.map(fold).join("\r\n")}\r\n`;
}

/** His face as base64, or undefined: a card without a photo still saves. */
async function faceBase64(): Promise<string | undefined> {
  try {
    const res = await fetch(FACE_URL);
    if (!res.ok) return undefined;
    const bytes = new Uint8Array(await res.arrayBuffer());
    let bin = "";
    for (const b of bytes) bin += String.fromCharCode(b);
    return btoa(bin);
  } catch {
    return undefined;
  }
}

export async function downloadBashCard(number: string): Promise<void> {
  const card = buildBashVCard({
    number,
    photoJpegBase64: await faceBase64(),
  });
  const url = URL.createObjectURL(new Blob([card], { type: "text/vcard" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = "Bash.vcf";
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
